/* import __COLOCATED_TEMPLATE__ from './market-percent-input.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/*
 * @param {Number} value - the percentage value of the input
 * @param {Number} maximumFractionDigits - the maximum fraction digits of the input value,
 * i.e. what place the value is rounded to. By default rounds to whole numbers
 * @param {Number} maximumValue - the maximum value of the input
 * @param {Number} minimumValue - the minimum value of the input
 * @param {Number} exponent - the number of decimal places to shift numbers before formatting
 * @param {Action} onChange - called when the value changes
 */

import { inject as service } from '@ember/service';
import { set, action, computed } from '@ember/object';
import Component from '@ember/component';
import { tagName } from '@ember-decorators/component';
let MarketPercentInput = (_dec = tagName(''), _dec2 = service('formatter'), _dec3 = computed('formatter', 'percentFormatter', 'value'), _dec4 = computed('formatter', 'maximumFractionDigits', 'percentFormatter', 'unfocusedPlaceholderPercentage'), _dec5 = computed('exponent', 'formatter', 'maximumFractionDigits', 'maximumValue', 'minimumValue'), _dec(_class = (_class2 = class MarketPercentInput extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "formatterService", _descriptor, this);
    _defineProperty(this, "unfocusedPlaceholderPercentage", 0);
    _defineProperty(this, "maximumFractionDigits", null);
    _defineProperty(this, "maximumValue", null);
    _defineProperty(this, "minimumValue", null);
    _defineProperty(this, "exponent", null);
    _defineProperty(this, "value", null);
  }
  get displayValue() {
    if (this.value || this.value === 0) {
      let value = this.value;
      if (typeof this.value === 'string') {
        value = this.formatter.parse(value);
      }
      value = this.formatter.format(value);
      return typeof value === 'string' ? value : '';
    }
    return '';
  }
  get placeholder() {
    if (this.maximumFractionDigits !== null) {
      return this.formatter.format(this.unfocusedPlaceholderPercentage, {
        maximumFractionDigits: this.maximumFractionDigits
      });
    } else {
      return this.formatter.format(this.unfocusedPlaceholderPercentage);
    }
  }
  get formatter() {
    const formatter = this.formatterService.buildPercentFormatter();
    if (this.maximumFractionDigits !== null) {
      formatter.setMaximumFractionDigits(this.maximumFractionDigits);
    }
    if (this.maximumValue !== null) {
      formatter.setMaximum(this.maximumValue);
    }
    if (this.minimumValue !== null) {
      formatter.setMinimum(this.minimumValue);
    }
    if (this.exponent !== null) {
      formatter.setExponent(this.exponent);
    }
    return formatter;
  }
  async registerChangeHandler(marketInput) {
    this.marketInput = marketInput;
    this.input = await this.marketInput.getInputElement();
    this.input.addEventListener('change', this._handleChange.bind(this));
  }
  _handleChange() {
    let newValue = this.formatter.parse(this.input.value);
    const formattedValue = newValue || newValue === 0 ? this.formatter.format(newValue) : '';

    // Here we set the value of both the input and the marketInput because
    // the marketInput requires the value attribute to correctly style the market label.
    this.input.value = formattedValue;
    this.marketInput.value = formattedValue;

    // Re-parse newValue from the formatted value to arrive at the correct number of
    // decimal places.
    newValue = this.formatter.parse(formattedValue);
    if (newValue !== this.value) {
      set(this, 'value', newValue);
      this.onChange?.(newValue);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "formatterService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "displayValue", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "displayValue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "placeholder", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "placeholder"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "formatter", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "formatter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "registerChangeHandler", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "registerChangeHandler"), _class2.prototype), _class2)) || _class);
export { MarketPercentInput as default };